import Screen from "@/src/components/Screen";
import { Card } from "@/src/components/shad/card";

import Offers from "./Offers";

const MyOffers = () => {
  return (
    <Screen>
      <Card>
        <div className="md:p-6 p-4">
          <Offers />
        </div>
      </Card>
    </Screen>
  );
};

export default MyOffers;
